import { createItem } from '@directus/sdk';
import { useMutation } from '@tanstack/react-query';

import { useLoggedInUser } from '../../hooks/useLoggedInUser.ts';
import { directusClient } from '../../services/directusClient/directusClient.ts';
import { tanstackQueryClient } from '../../services/tanstackQueryClient.ts';

export const useIncompleteEventItems = () => {
  const { promoter } = useLoggedInUser();
  const promoterId = promoter.data?.id;

  const createMutation = useMutation({
    mutationFn: async () => {
      const result = await directusClient.request(
        createItem('incomplete_events', { promoter: promoterId as unknown as string }),
      );

      return result.id?.toString(10) ?? undefined;
    },
    onSuccess: async () => {
      await tanstackQueryClient.invalidateQueries({
        queryKey: ['incomplete_events'],
        exact: false,
      });
    },
  });

  return { createMutation };
};
